var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0308 40.822L0 21.7912V25.679C0 26.7092 0.40822 27.7006 1.1469 28.4199L16.2899 43.5629C17.8062 45.0791 20.2749 45.0791 21.7912 43.5629L33.8628 31.4912C35.3791 29.975 35.3791 27.5062 33.8628 25.99L19.0308 40.822Z",
    fill: "#2A5050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2899 33.8434C17.048 34.6015 18.0394 34.9903 19.0308 34.9903C20.0222 34.9903 21.0136 34.6015 21.7717 33.8434L33.8434 21.7717C35.3596 20.2555 35.3596 17.7867 33.8434 16.2705L18.7004 1.12746C17.9811 0.40822 16.9897 0 15.9595 0H3.88781C1.74951 0 0 1.74951 0 3.88781V15.9595C0 16.9897 0.40822 17.9811 1.1469 18.7004L16.2899 33.8434ZM3.88781 3.88781H15.9595L31.1025 19.0308L19.0308 31.1025L3.88781 15.9595V3.88781Z",
    fill: "#2A5050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26191 10.6915C9.6039 10.6915 10.6918 9.60358 10.6918 8.26159C10.6918 6.91961 9.6039 5.83171 8.26191 5.83171C6.91993 5.83171 5.83203 6.91961 5.83203 8.26159C5.83203 9.60358 6.91993 10.6915 8.26191 10.6915Z",
    fill: "#2A5050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagPrimary);
export default __webpack_public_path__ + "static/media/tag-primary.c9781ae23557817393395fa1db7616ad.svg";
export { ForwardRef as ReactComponent };